import { Injectable } from '@angular/core';
import { PolicyDetailsServiceHandler } from './policydetails.services.handler';
import { HttpClient } from '@angular/common/http';
import { SettingService } from 'src/app/system-common/services/setting.service';

@Injectable({
  providedIn: 'root',
})
export class PolicyDetailsService extends PolicyDetailsServiceHandler {
  constructor(http: HttpClient, settingService: SettingService) {
    super(http, settingService);
  }
}
